import * as React from 'react'
import { SVGProps } from 'react'
const SvgRadioIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect x={6} y={5} width={20} height={20} rx={5} stroke={props.color ?? '#CC3E76'} strokeWidth={2} />
  </svg>
)
export default SvgRadioIcon
